export default __webpack_public_path__ + "static/logo-91a35e84d1e618ab9a48687ac19cc977.svg";